module.exports = __webpack_public_path__ + "img/131.26352930.jpg";